import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckboxComponent } from './checkbox.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: CheckboxComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class CheckboxRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/checkbox/checkbox-routing.module.ts